import { Component } from "react";
import { Link,withRouter } from "react-router-dom";
import logo from "../../assets/img/logo-free.png";
import "../../assets/css/style2.css";
import "../../assets/css/custom.css";
import { isAuthenticated } from './../pages/UserFunctions'
class Header extends Component {
  logOut(e) {
    e.preventDefault()
    localStorage.removeItem('usertoken')
    this.props.history.push(`/`)
  }
  render() {
    const loginRegLink = (
        <ul className="navbar-nav ml-auto">
            <li className="nav-item dropdown">
                <Link to="/" onClick={() => window.location.href = '/'} className="nav-link dropdown-toggle menu">Home</Link>
            </li>
            <li className="nav-item dropdown">
                <Link to="/aboutus" className="nav-link dropdown-toggle menu">About Us</Link>
            </li>
            <li className="nav-item dropdown">
          <Link to="#" data-toggle="dropdown" className="nav-link dropdown-toggle menu">Tutorial <b className="caret"></b></Link>
          <ul className="dropdown-menu">
          <li><a href="/tutorial/php/1" className="linkstyle">PHP</a></li>
          <li><a href="/tutorial/javascript/3" className="linkstyle">Javascript</a></li>
          <li><a href="/tutorial/jquery/64" className="linkstyle">jQuery</a></li>
          <li><a href="/tutorial/ajax/4" className="linkstyle">Ajax</a></li>
          <li><a href="/tutorial/codeigniter/68" className="linkstyle">Codeigniter</a></li>
          <li><a href="/tutorial/laravel/101" className="linkstyle">Laravel</a></li>
          <li><a href="/tutorial/api/127" className="linkstyle">PHP API</a></li>
          <li><a href="/tutorial/react/137" className="linkstyle">ReactJS</a></li>
          <li className="marginzero"><a href="/tutorial/node/151" className="linkstyle">NodeJS</a></li>
         </ul>
        </li>
          <li className="nav-item dropdown">
          <Link to="#" data-toggle="dropdown" className="nav-link dropdown-toggle menu">Example<b className="caret"></b></Link>
          <ul className="dropdown-menu">
          <li><a href="/example/php/1" className="linkstyle">PHP</a></li>
          <li><a href="/example/javascript/23" className="linkstyle">Javascript</a></li>
          <li><a href="/example/jquery/63" className="linkstyle">jQuery</a></li>
          <li><a href="/example/ajax/33" className="linkstyle">Ajax</a></li>
          <li><a href="/example/codeigniter/66" className="linkstyle">Codeigniter</a></li>
          <li><a href="/example/laravel/68" className="linkstyle">Laravel</a></li>
          <li><a href="/example/api/68" className="linkstyle">API</a></li>
          <li><a href="/example/react/83" className="linkstyle">ReactJS</a></li>
          <li className="marginzero"><a href="/example/node/84" className="linkstyle">NodeJS</a></li>
         </ul>
        </li>
          <li className="nav-item dropdown">
          <a href="void" to="#" data-toggle="dropdown" className="nav-link dropdown-toggle menu">Interview QA <b className="caret"></b></a>
          <ul className="dropdown-menu">
          <li><a href="/interview/php" className="linkstyle">PHP</a></li>
          <li><a href="/interview/javascript" className="linkstyle">Javascript</a></li>
          <li><a href="/interview/jquery" className="linkstyle">jQuery</a></li>
          <li><a href="/interview/ajax" className="linkstyle">Ajax</a></li>
          <li><a href="/interview/codeigniter" className="linkstyle">Codeigniter</a></li>
          <li><a href="/interview/laravel" className="linkstyle">Laravel</a></li>
          <li><a href="/interview/api" className="linkstyle">API</a></li>
          <li><a href="/interview/react" className="linkstyle">ReactJS</a></li>
          <li><a href="/interview/node" className="linkstyle">Node</a></li>
          <li><a href="/interview/javascriptchallenges" className="linkstyle">Javascript Challenges</a></li>
          <li><a href="/interview/mongodb" className="linkstyle">Mongo DB</a></li>
          <li><a href="/interview/database" className="linkstyle">Database</a></li>
          <li><a href="/interview/techlead" className="linkstyle">Tech Lead</a></li>
          <li className="marginzero"><a href="/interview/aws" className="linkstyle">AWS</a></li>
         </ul>
        </li>
            <li className="nav-item dropdown">
                <Link to="/contactus" className="nav-link dropdown-toggle menu">Contact Us</Link>
            </li>
       
            <li className="dropdown">
                <Link to="/postquestion" className="btn btn-success navbtn">Post Question</Link>
            </li>
        </ul>
    )

    const userLink = (
        <ul className="navbar-nav ml-auto">
            <li className="nav-item dropdown">
                <Link to="/" className="nav-link dropdown-toggle menu">Home</Link>
            </li>
             <li className="dropdown">
          <a href="void" className="dropdown-toggle linkstyle" data-toggle="dropdown">Tutorial <b className="caret"></b></a>
          <ul className="dropdown-menu">
          <li><a href="/tutorial/php/1" className="linkstyle">PHP</a></li>
          <li><a href="/tutorial/javascript/3" className="linkstyle">Javascript</a></li>
          <li><a href="/tutorial/jquery/64" className="linkstyle">jQuery</a></li>
          <li><a href="/tutorial/ajax/4" className="linkstyle">Ajax</a></li>
          <li><a href="/tutorial/codeigniter/68" className="linkstyle">Codeigniter</a></li>
          <li><a href="/tutorial/laravel/101" className="linkstyle">Laravel</a></li>
          <li><a href="/tutorial/api/127" className="linkstyle">PHP API</a></li>
          <li className="marginzero"><a href="/tutorial/react/137" className="linkstyle">ReactJS</a></li>
         </ul>
        </li>
            <li className="nav-item dropdown">
                <Link to="/aboutus" className="nav-link dropdown-toggle menu">About Us</Link>
            </li>
            <li className="nav-item dropdown">
                <Link to="/contactus" className="nav-link dropdown-toggle menu">Contact Us</Link>
            </li>
            <li className="nav-item dropdown">
                <Link to="/profile" className="nav-link dropdown-toggle menu">Profile</Link>
            </li>
            <li className="nav-item dropdown">
                <a href="/logout" onClick={this.logOut.bind(this)} className="nav-link dropdown-toggle menu">Logout</a>
            </li>
            <li className="dropdown">
                <Link to="/postfreeads" className="btn btn-success navbtn">Post Free Ads</Link>
            </li>
        </ul>
    )
    return (
      <header>
         <div className="top-menu">
            <div className="container">
               <div className="line">
                  <div className="topleft">info@ittrainingonline.co.in</div>
                  
                  <div className="topright">Call : 9911097721
                 
                  </div>
               </div>
            </div>
         </div>
           
         <nav className="navbar navbar-expand-lg navbar-light">
          <div className="container">
            <Link to="/" className="nav-link dropdown-toggle menu"><img src={logo} alt="logo" className="img-fluid"/>
            </Link> 
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" id="nav-icon">
            <span className="navbar-toggler-icon"></span>
            <span></span>
            <span></span>
            <span></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              {isAuthenticated() ? userLink : loginRegLink}
            </div>
          </div>
         </nav>
        
        
      </header>
    );
  }
}

export default withRouter(Header);
